import { combineReducers } from 'redux';
import list from './list.reducer';

const listQscriptReducer = combineReducers({
  list,
});

export default listQscriptReducer;
